<template>
  <div class="check-in-info">
    <div :style="{opacity: +!refreshLoading}" style="flex-shrink: 0;width: 100%;">
      <div class="distance" v-if="!queryParams.deviceLatLng || !queryParams.deviceLatLng.latitude || !queryParams.deviceLatLng.longitude">获取定位失败，请重新获取</div>
      <div class="distance" v-else-if="clockState === 'none'">暂无排班</div>
      <div class="distance" v-else-if="clockState === 'rest'">今日休息</div>
      <div class="distance" v-else-if="isWithinRange">您当前距离打卡点范围还有{{ distanceFormat(queryParams.distance) }}</div>
      <div class="distance" v-else>您已到达打卡范围，请完成{{ clockState === 'clock_out' ? '下班' : '上班' }}打卡</div>
    </div>
    <div class="current-clock-not-out" v-if="activeSchedule && activeSchedule.scheduleType === 'WORK'">
      <div
        class="current-clock-not-out-item"
        :class="{'is-active': clockState === 'clock_in'}"
      >
        <div class="current-clock-not-out-item__title">上班{{ activeSchedule.startTime ? activeSchedule.startTime.split(' ')[1].slice(0,-3) : '--' }}</div>
        <div class="current-clock-not-out-item__min-title" v-if="clockInRecord">{{ clockInRecord.clockTime ? clockInRecord.clockTime.split(' ')[1].slice(0,-3) : '' }}{{ isClockInLate ? ' 已迟到' : '' }}</div>
        <div class="current-clock-not-out-item__min-title" v-else-if="missingClockInRecord || frontendMissingClockIn">缺卡</div>
        <div class="current-clock-not-out-item__min-title" v-else>待打卡</div>
      </div>
      <div
        class="current-clock-not-out-item"
        :class="{'is-active': clockState === 'clock_out'}"
      >
        <div class="current-clock-not-out-item__title">下班{{ activeSchedule.endTime ? activeSchedule.endTime.split(' ')[1].slice(0,-3) : '--' }}</div>
        <div class="current-clock-not-out-item__min-title" v-if="clockOutRecord">{{ clockOutRecord.clockTime ? clockOutRecord.clockTime.split(' ')[1].slice(0,-3) : '' }}</div>
        <div class="current-clock-not-out-item__min-title" v-else-if="clockInRecord || missingClockInRecord || frontendMissingClockIn">待打卡</div>
        <div class="current-clock-not-out-item__min-title" v-else>--</div>
      </div>
    </div>
    <div class="check-in-box">
      <div class="check-in-btn" v-if="checkInLoading || refreshLoading">
        <div class="radar-scanner"></div>
      </div>
      <div class="check-in-btn checked-in-btn" v-else-if="clockState === 'none'">
        <div class="check-in-btn__title">暂无排班</div>
      </div>
      <div class="check-in-btn checked-in-btn" v-else-if="clockState === 'rest'">
        <div class="check-in-btn__title">休息日</div>
      </div>
      <div class="check-in-btn checked-in-btn" v-else-if="clockState === 'missing_in'" @click="handleMissingClockIn">
        <div class="check-in-btn__title">上班缺卡</div>
      </div>
      <div
        class="check-in-btn checked-in-btn"
        v-else-if="clockState === 'done'"
        @click="handleCheckedIn"
      >
        <div class="check-in-btn__title">已打卡</div>
        <div class="check-in-btn__min-title">{{ clockOutRecord && clockOutRecord.clockTime ? clockOutRecord.clockTime.split(' ')[1] : '' }}</div>
      </div>
      <div class="check-in-btn" v-else @click="handleToTakePhoto">
        <div class="check-in-btn__title">{{ clockState === 'clock_out' ? '下班打卡' : '上班打卡' }}</div>
        <div class="check-in-btn__min-title">{{ currentTime }}</div>
      </div>
      <div class="warehouse-name" :style="{opacity: +!refreshLoading}">
        <van-icon name="checked" color="#EC892E" size="16px" style="margin-right: 8px;flex-shrink: 0;" v-if="isWithinRange" />
        <van-icon name="clear" color="#C9C2BB" size="16px" style="margin-right: 8px;flex-shrink: 0;"  v-else />
        {{ `打卡仓库：${queryParams.concatenatedName ? queryParams.concatenatedName.replace(/,/,' ') : ''}` }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  Image,
  Field,
  Cell,
  CellGroup,
  Form,
  Button,
  Checkbox,
  CheckboxGroup,
  Icon,
} from "vant";
import { parseTime } from "@/utils/ruoyi.js";
import { getTodayAndYesterdayUserSchedule, clockRecordAdd } from "@/api/material/checkIn/index.js";
import { geocoder } from '@/api/dispatch/index.js';
import eventBus from "@/utils/bus.js";

function checkInTakePhotoFinish(url){
  console.log("H5 checkInTakePhotoFinish",url);
  eventBus.$emit("checkInTakePhotoFinish",url);
};
window.checkInTakePhotoFinish = checkInTakePhotoFinish;

export default {
  name: "dispatch-address-info",
  components: {
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Icon.name]: Icon,
  },
  props: {
    queryParams: {
      type: Object,
      default: () => ({
        deviceLatLng: {},
      })
    },
    checkInRangeValue: {
      type: Number,
      default: 0
    },
    refreshLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {},
      checkInLoading: false,
      timer: null,
      currentTime: "",
      activeSchedule: null,
      scheduleData: {},
      clockState: "none",
      frontendMissingClockIn: false,
      clockRecordAddTimestamp: null,
    };
  },
  mounted() {
    if(process.env.NODE_ENV === "development") {
      window._this = this;
    }
    this.timer = setInterval(() => {
      this.currentTime = parseTime(+new Date(),"{h}:{i}:{s}");
    }, 1000);
    eventBus.$on("checkInTakePhotoFinish", this.handleCheckIn);
  },
  beforeDestroy() {
    if(this.timer) {
      clearInterval(this.timer);
    };
    eventBus.$off("checkInTakePhotoFinish");
  },
  watch: {
    "queryParams.mwLevelOneId": {
      async handler(mwLevelOneId, oldId) {
        if(oldId === mwLevelOneId) return;
        if(!mwLevelOneId) {
          this.activeSchedule = null;
          this.clockState = "none";
          return;
        }
        await this.getScheduleInfo();
        console.log("watch mwLevelOneId", mwLevelOneId);
        this.$emit("refresh");
      },
      deep: true,
    },
  },
  computed: {
    isWithinRange() {
      return this.queryParams.deviceLatLng && this.queryParams.deviceLatLng.latitude && this.queryParams.deviceLatLng.longitude && this.queryParams.distance <= this.checkInRangeValue;
    },
    clockInRecord() {
      if (!this.activeSchedule || !this.activeSchedule.materialClockRecordList) return null;
      return this.activeSchedule.materialClockRecordList.find(
        r => r.clockType === "CLOCK_IN" && r.clockStatus !== "MISSING"
      ) || null;
    },
    clockOutRecord() {
      if (!this.activeSchedule || !this.activeSchedule.materialClockRecordList) return null;
      const records = this.activeSchedule.materialClockRecordList.filter(
        r => r.clockType === "CLOCK_OUT" && r.clockStatus !== "MISSING"
      );
      if (!records.length) return null;
      return records.reduce((latest, r) =>
        r.clockTime > latest.clockTime ? r : latest
      );
    },
    missingClockInRecord() {
      if (!this.activeSchedule || !this.activeSchedule.materialClockRecordList) return null;
      return this.activeSchedule.materialClockRecordList.find(
        r => r.clockType === "CLOCK_IN" && r.clockStatus === "MISSING"
      ) || null;
    },
    isClockInLate() {
      if (!this.clockInRecord || !this.activeSchedule || !this.activeSchedule.startTime) return false;
      return new Date(this.clockInRecord.clockTime).getTime() > new Date(this.activeSchedule.startTime).getTime();
    },
  },
  methods: {
    getCurrentTimeStr() {
      const now = new Date();
      const h = String(now.getHours()).padStart(2, '0');
      const m = String(now.getMinutes()).padStart(2, '0');
      const s = String(now.getSeconds()).padStart(2, '0');
      return `${h}:${m}:${s}`;
    },
    getCurrentDateTimeStr() {
      const now = new Date();
      const Y = now.getFullYear();
      const M = String(now.getMonth() + 1).padStart(2, '0');
      const D = String(now.getDate()).padStart(2, '0');
      const h = String(now.getHours()).padStart(2, '0');
      const m = String(now.getMinutes()).padStart(2, '0');
      const s = String(now.getSeconds()).padStart(2, '0');
      return `${Y}-${M}-${D} ${h}:${m}:${s}`;
    },
    async getScheduleInfo() {
      try {
        this.checkInLoading = true;
        let { data } = await getTodayAndYesterdayUserSchedule();
        this.scheduleData = data || {};
        this.activeSchedule = this.determineActiveSchedule(
          data && data.todayUserSchedule,
          data && data.yesterdayUserSchedule,
          data && data.tomorrowUserSchedule
        );
        this.updateClockState();
        this.checkInLoading = false;
        setTimeout(() => {
          console.log("getScheduleInfo", this.deepClone({
            activeSchedule: this.activeSchedule,
            clockState: this.clockState,
            clockInRecord: this.clockInRecord,
            clockOutRecord: this.clockOutRecord,
            missingClockInRecord: this.missingClockInRecord,
          }));
        }, 1000);
        return Promise.resolve(this.activeSchedule);
      } catch (error) {
        this.activeSchedule = null;
        this.clockState = "none";
        this.checkInLoading = false;
        return Promise.reject(error);
      }
    },
    determineActiveSchedule(todaySchedule, yesterdaySchedule, tomorrowSchedule) {
      const now = this.getCurrentDateTimeStr();
      const schedules = [yesterdaySchedule, todaySchedule, tomorrowSchedule];
      for (const schedule of schedules) {
        if (
          schedule &&
          schedule.scheduleType === "WORK" &&
          schedule.allowClockStartTime <= now &&
          now < schedule.allowClockEndTime
        ) {
          return schedule;
        }
      }
      if (todaySchedule && todaySchedule.scheduleType !== "WORK") {
        return todaySchedule;
      }
      return null;
    },
    updateClockState() {
      this.frontendMissingClockIn = false;
      if (!this.activeSchedule) {
        this.clockState = "none";
        return;
      }
      if (this.activeSchedule.scheduleType !== "WORK") {
        this.clockState = "rest";
        return;
      }

      const now = this.getCurrentDateTimeStr();
      const { endTime } = this.activeSchedule;

      if (now < endTime) {
        // Phase A: 上班打卡时段 (allowClockStartTime <= now < endTime)
        if (this.clockInRecord) {
          this.clockState = "done";
        } else if (this.missingClockInRecord) {
          this.clockState = "missing_in";
        } else {
          this.clockState = "clock_in";
        }
      } else {
        // Phase B: 下班打卡时段 (endTime <= now < allowClockEndTime)
        if (!this.clockInRecord && !this.missingClockInRecord) {
          this.frontendMissingClockIn = true;
        }
        this.clockState = "clock_out";
      }
    },
    async handleCheckIn(pictureUrl) {
      console.log("handleCheckIn", pictureUrl);
      console.log("queryParams", this.deepClone(this.queryParams));
      try {
        this.checkInLoading = true;
        let message = this.clockState === "clock_out" ? "下班打卡成功" : "上班打卡成功";
        let clockAddr = await this.getClockAddr();
        await clockRecordAdd({
          pictureUrl,
          clockAddr,
          differentLocationClock: this.isWithinRange ? "0" : "1",
          materialScheduleId: this.activeSchedule.id,
          mwLevelOneId: this.queryParams.mwLevelOneId,
        });
        this.clockRecordAddTimestamp = +new Date();
        console.log("打卡成功", JSON.stringify({
          clockState: this.clockState,
          materialScheduleId: this.activeSchedule.id,
          mwLevelOneId: this.queryParams.mwLevelOneId,
        }));
        this.$toast({
          message,
          position: "top",
          icon: "checked",
          className: "material-check-in-toast",
        });
        await this.getScheduleInfo();
        this.checkInLoading = false;
        window.uni.postMessage({
          data: { type: "checkInFinish" }
        });
        return Promise.resolve(true);
      } catch (error) {
        this.checkInLoading = false;
        return Promise.reject(error);
      }
    },
    async getClockAddr(){
      try {
        let { result } = await geocoder({location:`${this.queryParams.deviceLatLng.latitude},${this.queryParams.deviceLatLng.longitude}`,get_poi:1,poi_options:'policy=2'});
        let clockAddr = {};
        if(result.address_component.nation && result.address_component.nation !== "中国") {
            clockAddr = {
                adcode:result.ad_info.nation_code || "",
                province:result.address_component.ad_level_1 || "",
                city:result.address_component.ad_level_2 || "",
                district:result.address_component.ad_level_3 || "",
                detailedAddress:result.address,
                title:result.address,
                latitude:result.location.lat,
                longitude:result.location.lng,
            };
        }else if(result.pois.length) {
            clockAddr = {
                adcode:result.ad_info.adcode,
                province:result.address_component.province,
                city:result.address_component.city,
                district:result.address_component.district || "",
                detailedAddress:result.pois[0].address,
                title:result.pois[0].title,
                latitude:result.location.lat,
                longitude:result.location.lng,
            };
        }else if(result.address_component.province && result.address_component.city){
            let title = "";
            let address_reference_keys = result.address_reference && Object.keys(result.address_reference);
            if(address_reference_keys && address_reference_keys.length) {
                title = result.address_reference[address_reference_keys[0]].title;
            }
            clockAddr = {
                adcode:result.ad_info.adcode,
                province:result.address_component.province,
                city:result.address_component.city,
                district:result.address_component.district || "",
                detailedAddress:result.address,
                title: title ? title : `${result.address_component.district || result.address_component.city}`,
                latitude:result.location.lat,
                longitude:result.location.lng,
            };
        }else {
            clockAddr = {
                adcode:result.ad_info.adcode,
                province:'',
                city:'',
                district:'',
                detailedAddress:'',
                title:'',
                latitude:result.location.lat,
                longitude:result.location.lng,
            };
        }
        console.log("逆地址解析成功",JSON.stringify(clockAddr))
        return Promise.resolve(clockAddr);
      } catch (error) {
        console.log("逆地址解析失败",error);
        return Promise.resolve({
          adcode:'',
          province:'',
          city:'',
          district:'',
          detailedAddress:'',
          title:'',
          latitude:this.queryParams.deviceLatLng.latitude,
          longitude:this.queryParams.deviceLatLng.longitude,
        });
      }
    },
    async handleToTakePhoto(){
      if(this.refreshLoading || this.checkInLoading) return;
      if(!this.queryParams.deviceLatLng.latitude || !this.queryParams.deviceLatLng.longitude) {
        this.$toast({
          message:"获取定位失败，请重新获取",
          position: "top",
          icon: "clear",
          className: "material-check-in-toast",
        });
        return;
      };
      if(this.clockState === "clock_in" && !this.isWithinRange) {
        this.$toast({
          message:"您未到打卡点，无法打卡",
          position: "top",
          icon: "clear",
          className: "material-check-in-toast",
        });
        return;
      };
      let nowTimestamp = +new Date();
      if(this.clockRecordAddTimestamp && nowTimestamp - this.clockRecordAddTimestamp < 5000) {
        this.$toast({
          message:"打卡过于频繁，请稍后再试",
          position: "top",
          icon: "clear",
          className: "material-check-in-toast",
        });
        return;
      }
      if(process.env.NODE_ENV === "development") {
        this.handleCheckIn("http://192.168.101.99:9098/tms/2025/07/03/20250703092413A010.png");
      }else {
        window.uni.navigateTo({ url: "/packMaterial/home/checkInTakePhoto/index" });
      }
    },
    handleCheckedIn(){
      this.$toast({
        message:"已完成打卡",
        position: "top",
        icon: "warning",
        className: "material-check-in-toast",
      });
    },
    handleMissingClockIn(){
      this.$toast({
        message:"上班缺卡",
        position: "top",
        icon: "warning",
        className: "material-check-in-toast",
      });
    },
    distanceFormat(value) {
      if(!value || value <= 0) return 0;
      if(value >= 1000) {
        return `${this.$math(value,1000).divide().toFixed(2)}公里`;
      }else {
        return `${value}米`;
      }
    }
  },
};
</script>

<style lang="scss">
  .material-check-in-toast {
    flex-direction: row;
    max-width: 90vw;
    width: auto;
    align-items: center;
    height: auto;
    min-height: initial;
    background: rgba(0, 0, 0, .6);
    border-radius: 8px;
    padding: 12px 16px;
    top: 10%;
    .van-icon {
      font-size: 14px;
      line-height: 14px;
      margin-right: 6px;
    }
    .van-icon-clear {
      color: #FF484A;
    }
    .van-icon-checked {
      color: #EC892E;
    }
    .van-icon-warning {
      color: #669EE6;
    }
    .van-toast__text {
      font-size: 14px;
      line-height: 22px;
      margin: 0;
      white-space: nowrap;      
    }
  }
</style>

<style scoped lang="scss">
.check-in-info {
  min-height: 43vh;
  // box-sizing: border-box;
  position: relative;
  z-index: 99;
  background-color: #FFF;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  .distance {
    width: 100%;
    font-size: 14px;
    line-height: 22px;
    color: #3D3833;
    padding: 12px 0;
    border-bottom: 1px solid #EFF0F4;
    flex-shrink: 0;
    align-self: flex-start;
  }
  .current-clock-not-out {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 7px;
    .current-clock-not-out-item {
      background-color: #F8F8F8;
      border-radius: 4px;
      overflow: hidden;
      padding: 12px 8px;
      border: 1px solid #F8F8F8;
      &__title {
        font-size: 16px;
        line-height: 24px;
        color: #3D3833;
        margin-bottom: 6px;
      }
      &__min-title {
        font-size: 12px;
        line-height: 20px;
        color: #85807B;
      }
    }
    .current-clock-not-out-item.is-active {
      border-color: #FFBD2D;
      background-color: #FFF8E9;
      .current-clock-not-out-item__title,
      .current-clock-not-out-item__min-title {
        color: #FFBD2D !important;
      }
    }
  }
  .check-in-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    overflow: hidden;
    padding: 2vh;
    .check-in-btn {
      background: linear-gradient( 154deg, #FFCB9B 0%, #EC892E 100%);
      box-shadow: 1px 1px 12px 1px rgba(255,122,0,0.3);
      width: 131px;
      height: 131px;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      overflow: hidden;
      flex-shrink: 0;
      &__title {
        font-size: 20px;
        line-height: 28px;
        color: #FFF;
      }
      &__min-title {
        font-size: 16px;
        line-height: 24px;
        color: #FFF;
      }
      .radar-scanner {
        position: absolute;
        width: 50%;
        height: 50%;
        z-index: 99;
        transform-origin: bottom right;
        background: linear-gradient(90deg, rgba(236, 137, 46, 0) 0%, rgba(236, 137, 46, 0.1) 50%, rgba(236, 137, 46, 0.3) 100%);
        animation: radarScan 3s linear infinite;
        left: 0;
        top: 0;
      }
      @keyframes radarScan {
          0% {
              transform: rotate(0deg);
          }
          100% {
              transform: rotate(360deg);
          }
      }
    }
    .checked-in-btn {
      background: linear-gradient( 154deg, #ECEBE9 0%, #B8B0A8 100%);
      box-shadow: 1px 1px 12px 1px rgba(133,128,123,0.3);
    }
  }
  .warehouse-name {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 22px;
    color: #85807B;
    padding-top: 23px;
  }
}
</style>
